import React, { Component } from "react";
import { Page, Navbar, NavLeft, NavTitle, Link } from "framework7-react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster";

import { connect } from "react-redux";
import {
  getBatasWilayah,
  getSekolahSebaran,
} from "../../store/actions/Sebaran.actions";

// Perbaiki icon bawaan Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.6.0/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.6.0/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.6.0/images/marker-shadow.png",
});

class Sebaran extends Component {
  map = null;
  mapContainer = null;
  markerCluster = null;

  componentDidMount() {
    localStorage.setItem("current_url", this.$f7route.url);

    this.map = L.map(this.mapContainer).setView([-4.5, 136.3], 9);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors",
    }).addTo(this.map);

    // Ambil batas wilayah tanpa tooltip
    this.props.getBatasWilayah().then(() => {
      const geojson = this.props.batas_wilayah;
      if (geojson) {
        const layer = L.geoJSON(geojson, {
          style: {
            color: "#3388ff",
            weight: 2,
            fillOpacity: 0.1,
          },
          onEachFeature: (feature, layer) => {
            // Tooltip di-disable di sini
          },
        }).addTo(this.map);

        this.map.fitBounds(layer.getBounds());
      }
    });

    // Ambil data sekolah dan tampilkan marker cluster
    this.props.getSekolahSebaran().then(() => {
      const sekolahList = this.props.sekolah_sebaran;

      if (sekolahList && sekolahList.length > 0) {
        this.markerCluster = L.markerClusterGroup();

        sekolahList.forEach((sekolah) => {
          if (
            sekolah.lintang &&
            sekolah.bujur &&
            sekolah.lintang !== ".000000000000" &&
            sekolah.bujur !== ".000000000000" &&
            parseFloat(sekolah.bujur) > 80
          ) {
            const popup = `
              <strong>${sekolah.nama}</strong><br/>
              NPSN: ${sekolah.npsn}<br/>
              Alamat: ${sekolah.alamat_jalan}<br/>
              Jenjang: ${sekolah.bentuk_pendidikan}<br/>
              Status Sekolah: ${sekolah.status_sekolah}<br/>
              Kabupaten: ${sekolah.kabupaten}<br/>
              Kecamatan: ${sekolah.kecamatan}<br/>
            `;

            const marker = L.marker([
              parseFloat(sekolah.lintang),
              parseFloat(sekolah.bujur),
            ]).bindPopup(popup);

            this.markerCluster.addLayer(marker);
          }
        });

        this.map.addLayer(this.markerCluster);
      }
    });
  }

  componentWillUnmount() {
    if (this.map) {
      this.map.remove();
    }
  }

  render() {
    return (
      <Page name="sebaran">
        <Navbar sliding={false}>
          <NavLeft>
            <Link iconIos="f7:chevron_left" href="/">
              Beranda
            </Link>
          </NavLeft>
          <NavTitle sliding>Sebaran</NavTitle>
        </Navbar>

        <div style={{ position: "relative", height: "calc(100vh - 50px)" }}>
          <div
            ref={(el) => (this.mapContainer = el)}
            style={{ height: "100%", width: "100%" }}
          />
        </div>
      </Page>
    );
  }
}

const mapStateToProps = ({ Sebaran }) => ({
  batas_wilayah: Sebaran.batas_wilayah,
  sekolah_sebaran: Sebaran.sekolah_sebaran,
});

const mapDispatchToProps = (dispatch) => ({
  getBatasWilayah: () => dispatch(getBatasWilayah()),
  getSekolahSebaran: () => dispatch(getSekolahSebaran()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sebaran);
